module.exports = __webpack_public_path__ + "mustacheGlasses.svg?59520feeb047d7764ba2a1611959f628";